module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tos"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('p', {
    staticClass: "Default",
    staticStyle: {
      "text-align": "center",
      "tab-stops": "191.4pt"
    }
  }, [_c('b', [_c('span', {
    staticStyle: {
      "font-size": "10.0pt"
    },
    attrs: {
      "lang": "EN-CA"
    }
  }, [_vm._v("STRATICOM TECHNOLOGIES, INC. TERMS OF USE\n\t\t\t(“Agreement”)"), _c('o:p')], 1)])]), _vm._v(" "), _c('p', {
    staticClass: "Default",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "10.0pt"
    },
    attrs: {
      "lang": "EN-CA"
    }
  }, [_c('o:p', [_vm._v(" ")])], 1)]), _vm._v(" "), _c('p', {
    staticClass: "Default"
  }, [_c('span', {
    staticStyle: {
      "font-size": "10.0pt"
    },
    attrs: {
      "lang": "EN-CA"
    }
  }, [_vm._v("BY CLICKING “AGREE”\n\t\t\tBELOW YOU ACKNOWLEDGE YOU (“CLIENT”) WILL COMPLY WITH THE LEGAL CONDITIONS SET\n\t\t\tFORTH BELOW REGARDING CLIENT’S USE OF THE LICENSED SOFTWARE (as that term is\n\t\t\tdefined below) PROVIDED BY STRATICOM TECHNOLOGIES R&D INC. (“ST”). "), _c('o:p')], 1)]), _vm._v(" "), _c('p', {
    staticClass: "Default"
  }, [_c('span', {
    staticStyle: {
      "font-size": "10.0pt"
    },
    attrs: {
      "lang": "EN-CA"
    }
  }, [_c('o:p', [_vm._v(" ")])], 1)]), _vm._v(" "), _c('p', {
    staticClass: "Default"
  }, [_c('u', [_c('span', {
    staticStyle: {
      "font-size": "10.0pt"
    },
    attrs: {
      "lang": "EN-CA"
    }
  }, [_vm._v("Grant of License "), _c('o:p')], 1)])]), _vm._v(" "), _c('p', {
    staticClass: "Default"
  }, [_c('span', {
    staticStyle: {
      "font-size": "10.0pt"
    },
    attrs: {
      "lang": "EN-CA"
    }
  }, [_c('o:p', [_vm._v(" ")])], 1)]), _vm._v(" "), _c('p', {
    staticClass: "Default"
  }, [_c('span', {
    staticStyle: {
      "font-size": "10.0pt"
    },
    attrs: {
      "lang": "EN-CA"
    }
  }, [_vm._v("“Licensed Software”\n\t\t\tmeans certain demo/trial version of ChangeVU"), _c('sup', [_vm._v("TM")]), _vm._v(" software and\n\t\t\tresulting outputs and all related documentation, notes, instructions, and\n\t\t\trelated writings used in conjunction with the Licensed Software provided to\n\t\t\tClient by Straticom Technologies, Inc. In consideration of goodwill and market exposure\n\t\t\tearned by ST by providing demo/trial versions of the Licensed Software to\n\t\t\tassist Client’s evaluation of the Licensed Software, ST hereby grants to Client\n\t\t\ta limited, non-transferable, and non-exclusive license to use the Licensed\n\t\t\tSoftware for purposes of evaluation. This grant of license does not transfer or\n\t\t\tassign, in any manner, title of the Licensed Software to Client or any other\n\t\t\tparty. ST retains title and ownership of the Licensed Software, releases, trade\n\t\t\tsecrets, and any derivatives. The Licensed Software is copyrighted, licensed,\n\t\t\tand owned exclusively by ST. Under this license, Client may not modify, adapt,\n\t\t\ttranslate, reverse engineer, de-compile, or disassemble the Licensed Software,\n\t\t\tor create derivatives based on the Licensed Software or the accompanying\n\t\t\twritten materials. Client may not transfer, assign, give, sell, rent, lease,\n\t\t\tdistribute, or otherwise dispose of any Licensed Software. Client acknowledges\n\t\t\tthat violation of this Agreement may result in a suit for damages, injunctive\n\t\t\trelief, legal fees, and any other remedies available to ST in law or in equity.\n\t\t\t"), _c('o:p')], 1)]), _vm._v(" "), _c('p', {
    staticClass: "Default"
  }, [_c('span', {
    staticStyle: {
      "font-size": "10.0pt"
    },
    attrs: {
      "lang": "EN-CA"
    }
  }, [_c('o:p', [_vm._v(" ")])], 1)]), _vm._v(" "), _c('p', {
    staticClass: "Default"
  }, [_vm._m(0), _c('span', {
    staticStyle: {
      "font-size": "10.0pt"
    },
    attrs: {
      "lang": "EN-CA"
    }
  }, [_vm._v(": Client understands\n\t\t\tand expressly agrees that Client are responsible for determining the\n\t\t\tappropriateness for any given use by Client of the Licensed Software and Client\n\t\t\tassumes the risk for any such use. Client understands and expressly agrees that\n\t\t\tST and its products and services (i) are not in any way a substitute for the\n\t\t\tadvice of a lawyer and (ii) do not constitute legal advice, counsel, or\n\t\t\tbusiness advice of any sort, in any jurisdiction, on any matter. ST may make\n\t\t\tadditional releases of the Licensed Software that ST, in its sole discretion,\n\t\t\tdeems necessary. Client acknowledges that ST is under no continuing obligation\n\t\t\tto provide access to the Licensed Software and ST may terminate this Agreement\n\t\t\tat any time. "), _c('o:p')], 1)]), _vm._v(" "), _c('p', {
    staticClass: "Default"
  }, [_c('span', {
    staticStyle: {
      "font-size": "10.0pt"
    },
    attrs: {
      "lang": "EN-CA"
    }
  }, [_c('o:p', [_vm._v(" ")])], 1)]), _vm._v(" "), _c('p', {
    staticClass: "Default"
  }, [_vm._m(1), _c('span', {
    staticStyle: {
      "font-size": "10.0pt"
    },
    attrs: {
      "lang": "EN-CA"
    }
  }, [_vm._v(": No rights or\n\t\t\tlicenses, expressed or implied, are hereby granted to Client under any patents,\n\t\t\tcopyrights, or trade secrets of ST as a result of or related to this Agreement.\n\t\t\tClient agrees that the Licensed Software is proprietary to ST. In the event of\n\t\t\tan actual or threatened breach any provision of this Agreement, ST will be\n\t\t\tentitled to an injunction restraining Client from such breach and this will be\n\t\t\tin addition to any other rights or remedies that ST may have in law or in\n\t\t\tequity. "), _c('o:p')], 1)]), _vm._v(" "), _c('p', {
    staticClass: "Default"
  }, [_c('span', {
    staticStyle: {
      "font-size": "10.0pt"
    },
    attrs: {
      "lang": "EN-CA"
    }
  }, [_c('o:p', [_vm._v(" ")])], 1)]), _vm._v(" "), _c('p', {
    staticClass: "Default"
  }, [_c('span', {
    staticStyle: {
      "font-size": "10.0pt"
    },
    attrs: {
      "lang": "EN-CA"
    }
  }, [_vm._v("Client acknowledges\n\t\t\tthat the Licensed Software and each of its component parts are the valuable\n\t\t\ttrade secrets of ST and that the component parts and outputs are subject to\n\t\t\tcopyright laws. The use of a copyright notice will not be taken to indicate\n\t\t\tthat the Licensed Software or any of its component parts or output has been\n\t\t\tpublished. Client may not remove any copyright, trademark, or other\n\t\t\tintellectual property rights notices from the Licensed Software, including from\n\t\t\tany outputs generated by the Licensed Software. "), _c('o:p')], 1)]), _vm._v(" "), _c('p', {
    staticClass: "Default"
  }, [_c('span', {
    staticStyle: {
      "font-size": "10.0pt"
    },
    attrs: {
      "lang": "EN-CA"
    }
  }, [_c('o:p', [_vm._v(" ")])], 1)]), _vm._v(" "), _c('p', {
    staticClass: "Default"
  }, [_c('span', {
    staticStyle: {
      "font-size": "10.0pt"
    },
    attrs: {
      "lang": "EN-CA"
    }
  }, [_vm._v("Client warrants that\n\t\t\tall employees, agents, and representatives having access to the Licensed\n\t\t\tSoftware under this Agreement will do so with Client’s authorization and will\n\t\t\tcomply with the terms regarding the Licensed Software. Client assumes\n\t\t\tresponsibility for compliance by such employees, agents, and representatives\n\t\t\twith the confidentiality and proprietary protection provisions of this\n\t\t\tAgreement. Client will be responsible for any breach of this Agreement by\n\t\t\tClient’s employees, agents, and representatives who access to the Licensed\n\t\t\tSoftware. Client may not utilize the Licensed Software to perform service\n\t\t\tbureau work, time sharing, or process data for any third-party without the\n\t\t\tprior express written consent of the CEO of ST. "), _c('o:p')], 1)]), _vm._v(" "), _c('p', {
    staticClass: "Default"
  }, [_c('span', {
    staticStyle: {
      "font-size": "10.0pt"
    },
    attrs: {
      "lang": "EN-CA"
    }
  }, [_c('o:p', [_vm._v(" ")])], 1)]), _vm._v(" "), _c('p', {
    staticClass: "Default"
  }, [_c('span', {
    staticStyle: {
      "font-size": "10.0pt"
    },
    attrs: {
      "lang": "EN-CA"
    }
  }, [_vm._v("Client warrants that\n\t\t\tit will not seek to discover or to disclose any of ST’s trade secrets by\n\t\t\tdisassembling, decompiling, or otherwise reverse engineering the Licensed\n\t\t\tSoftware or any parts or outputs thereof. Client agrees to take all reasonable\n\t\t\tsteps to protect the Licensed Software and all documentation from theft or from\n\t\t\tuse by others contrary to the terms of this Agreement. Client agrees to\n\t\t\tpromptly notify ST in writing of any unauthorized use, infringement, misappropriation,\n\t\t\tdilution, or other violation of the Licensed Software of which Client becomes\n\t\t\taware. "), _c('o:p')], 1)]), _vm._v(" "), _c('p', {
    staticClass: "Default"
  }, [_c('span', {
    staticStyle: {
      "font-size": "10.0pt"
    },
    attrs: {
      "lang": "EN-CA"
    }
  }, [_c('o:p', [_vm._v(" ")])], 1)]), _vm._v(" "), _c('p', {
    staticClass: "Default"
  }, [_vm._m(2), _c('span', {
    staticStyle: {
      "font-size": "10.0pt"
    },
    attrs: {
      "lang": "EN-CA"
    }
  }, [_vm._v(": ST IS NOT\n\t\t\tLIABLE FOR ANY (i) LOST PROFITS, (ii) INDIRECT, INCIDENTAL, MULTIPLE,\n\t\t\tEXEMPLARY, PUNITIVE, CONSEQUENTIAL, OR ANY OTHER SPECIAL DAMAGES, INCLUDING BUT\n\t\t\tNOT LIMITED TO ANY LOSS OF DATA, PROSPECTIVE PROFITS ON ANTICIPATED SALES, OR\n\t\t\tON ACCOUNT OF EXPENDITURES, INVESTMENTS, LEASES, OR OTHER COMMITMENTS RELATING\n\t\t\tTO THE BUSINESS OR GOODWILL OF EITHER PARTY; OR (iii) ANY CLAIMS BROUGHT\n\t\t\tAGAINST CLIENT REGARDLESS OF WHETHER OR NOT ST HAD NOTICE OF SUCH CLAIMS. THIS\n\t\t\tLIMITATION OF DAMAGES WILL APPLY WITHOUT REGARD TO OTHER PROVISIONS OF THIS\n\t\t\tAGREEMENT. "), _c('o:p')], 1)]), _vm._v(" "), _c('p', {
    staticClass: "Default"
  }, [_c('span', {
    staticStyle: {
      "font-size": "10.0pt"
    },
    attrs: {
      "lang": "EN-CA"
    }
  }, [_c('o:p', [_vm._v(" ")])], 1)]), _vm._v(" "), _c('p', {
    staticClass: "Default"
  }, [_c('span', {
    staticStyle: {
      "font-size": "10.0pt"
    },
    attrs: {
      "lang": "EN-CA"
    }
  }, [_vm._v("ST MAKES NO\n\t\t\tWARRANTIES WITH RESPECT TO THE LICENSED SOFTWARE AND ST DISCLAIMS ALL WARRANTIES,\n\t\t\tEITHER EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO ANY IMPLIED WARRANTY OF\n\t\t\tMERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE. ST IS NOT RESPONSIBLE FOR\n\t\t\tAND MAKES NO REPRESENTATIONS OR WARRANTIES WITH REGARD TO THIRD-PARTY OPERATING\n\t\t\tSYSTEMS, COMPUTER HARDWARE, SOFTWARE, OR PERIPHERALS THAT CLIENT USES IN\n\t\t\tCONJUNCTION WITH THE LICENSED SOFTWARE. THE USE OF THE LICENSED SOFTWARE IS\n\t\t\t“AS-IS” AND WITH ALL FAULTS AND DEFECTS. "), _c('o:p')], 1)]), _vm._v(" "), _c('p', {
    staticClass: "Default"
  }, [_c('span', {
    staticStyle: {
      "font-size": "10.0pt"
    },
    attrs: {
      "lang": "EN-CA"
    }
  }, [_c('o:p', [_vm._v(" ")])], 1)]), _vm._v(" "), _c('p', {
    staticClass: "Default"
  }, [_vm._m(3), _c('span', {
    staticStyle: {
      "font-size": "10.0pt"
    },
    attrs: {
      "lang": "EN-CA"
    }
  }, [_vm._v(": Client hereby agrees to indemnify and\n\t\t\thold harmless ST from and against all claims, liability, loss, damages, or\n\t\t\texpenses, including reasonable attorneys' fees, by reason of any claim against ST\n\t\t\tbrought by any third party in regard to Client’s use of the Licensed Software. "), _c('o:p')], 1)]), _vm._v(" "), _c('p', {
    staticClass: "Default"
  }, [_c('span', {
    staticStyle: {
      "font-size": "10.0pt"
    },
    attrs: {
      "lang": "EN-CA"
    }
  }, [_c('o:p', [_vm._v(" ")])], 1)]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('p', {
    staticClass: "Default"
  }, [_c('span', {
    staticStyle: {
      "font-size": "10.0pt"
    },
    attrs: {
      "lang": "EN-CA"
    }
  }, [_c('o:p', [_vm._v(" ")])], 1)]), _vm._v(" "), _c('p', {
    staticClass: "Default"
  }, [_vm._m(5), _c('span', {
    staticStyle: {
      "font-size": "10.0pt"
    },
    attrs: {
      "lang": "EN-CA"
    }
  }, [_vm._v(": This Agreement\n\t\t\twill be construed according to the laws of the Province of Ontario and the\n\t\t\tfederal laws of Canada applicable thereto, without regard to conflict of laws\n\t\t\trules. Client and ST agree that for all disputes, claims, and controversies\n\t\t\tbetween them, whether individual, joint, or class in nature, arising from this\n\t\t\tAgreement or otherwise, including without limitation contract and tort\n\t\t\tdisputes, venue will be in Toronto, Ontario. If any action is brought related\n\t\t\tto this Agreement, ST will be entitled to recover, in addition to any other\n\t\t\taward granted, reasonable legal fees and expenses of litigation. Further,\n\t\t\trecognizing the unusual nature of software and trade secrets, Client\n\t\t\tacknowledges ST’s right to immediate injunctive relief in case of any breach of\n\t\t\tthis Agreement by Client, in addition to any other remedy in damages or in\n\t\t\tequity. "), _c('o:p')], 1)]), _vm._v(" "), _c('p', {
    staticClass: "Default"
  }, [_c('span', {
    staticStyle: {
      "font-size": "10.0pt"
    },
    attrs: {
      "lang": "EN-CA"
    }
  }, [_c('o:p', [_vm._v(" ")])], 1)]), _vm._v(" "), _c('p', {
    staticClass: "Default"
  }, [_vm._m(6), _c('span', {
    staticStyle: {
      "font-size": "10.0pt"
    },
    attrs: {
      "lang": "EN-CA"
    }
  }, [_vm._v(": In the event\n\t\t\tthat any one or more of the provisions, or parts of any provisions, contained\n\t\t\tin this Agreement will for any reason be held to be invalid, illegal, or\n\t\t\tunenforceable in any respect by a court of competent jurisdiction; (i) the same\n\t\t\twill not invalidate or otherwise affect any other provision hereof; (ii) this\n\t\t\tAgreement will be construed as if such invalid, illegal, or unenforceable\n\t\t\tprovision had never been contained herein; and (iii) any such invalid, illegal,\n\t\t\tor unenforceable provision will be modified so as to render it enforceable in a\n\t\t\tmanner most similar to and consistent with the original intent of this\n\t\t\tAgreement. "), _c('o:p')], 1)]), _vm._v(" "), _c('p', {
    staticClass: "Default"
  }, [_c('span', {
    staticStyle: {
      "font-size": "10.0pt"
    },
    attrs: {
      "lang": "EN-CA"
    }
  }, [_c('o:p', [_vm._v(" ")])], 1)]), _vm._v(" "), _c('p', {
    staticClass: "Default"
  }, [_c('span', {
    staticStyle: {
      "font-size": "10.0pt"
    },
    attrs: {
      "lang": "EN-CA"
    }
  }, [_vm._v("The failure of ST to\n\t\t\tenforce any rights granted hereunder or to take action against Client in the\n\t\t\tevent of any breach hereunder will not be deemed a waiver by ST as to\n\t\t\tsubsequent enforcement of rights or subsequent actions in the event of future\n\t\t\tbreaches. The expiration or termination of this Agreement will not affect the\n\t\t\tprovisions of this Agreement, which by their terms and meaning are of a\n\t\t\tcontinuing nature. Client is responsible for determination and payment of the\n\t\t\tapplicable taxes and similar charges, including but not limited to sales, use,\n\t\t\tand personal property taxes assessed against it as a result of its licensing,\n\t\t\tuse, or possession of the Licensed Software. "), _c('o:p')], 1)]), _vm._v(" "), _c('p', {
    staticClass: "Default"
  }, [_c('span', {
    staticStyle: {
      "font-size": "10.0pt"
    },
    attrs: {
      "lang": "EN-CA"
    }
  }, [_c('o:p', [_vm._v(" ")])], 1)]), _vm._v(" "), _c('p', {
    staticClass: "Default"
  }, [_c('span', {
    staticStyle: {
      "font-size": "10.0pt"
    },
    attrs: {
      "lang": "EN-CA"
    }
  }, [_vm._v("This Agreement\n\t\t\tconstitutes the entire agreement between ST and Client and supersedes and\n\t\t\tcancels any and all prior or contemporaneous proposals or agreements, written\n\t\t\tor oral, between ST and Client as to specific the subject matter hereof and the\n\t\t\tspecific Licensed Software specified herein and merges all prior advertising,\n\t\t\tdiscussions, proposals, purchase orders, agreements, presentations, communications\n\t\t\tand representations between them, whether written or oral. None of the parties\n\t\t\twill be bound by any conditions, definitions, warranties or representations\n\t\t\twith respect to any of the terms or conditions hereof other than as expressly\n\t\t\tprovided in this Agreement. This Agreement may only be modified by a written\n\t\t\tmodification signed by ST and Client. "), _c('o:p')], 1)]), _vm._v(" "), _c('p', {
    staticClass: "Default"
  }, [_c('span', {
    staticStyle: {
      "font-size": "10.0pt"
    },
    attrs: {
      "lang": "EN-CA"
    }
  }, [_c('o:p', [_vm._v(" ")])], 1)]), _vm._v(" "), _c('p', {
    staticClass: "Default"
  }, [_c('span', {
    staticStyle: {
      "font-size": "10.0pt"
    },
    attrs: {
      "lang": "EN-CA"
    }
  }, [_vm._v("CLIENT AGREES THAT HE/SHE\n\t\t\tHAS MADE HIS/HER OWN DETERMINATION OF THE SUITABILITY OF THE LICENSED SOFTWARE\n\t\t\tFOR ITS INTENDED USE AND BUSINESS PURPOSES AND AGREES THE LICENSED SOFTWARE IS\n\t\t\tPROVIDED FOR USE ‘AS-IS’, WITH ALL FAULTS AND DEFECTS, AND WITH NO WARRANTY OF\n\t\t\tANY KIND. "), _c('o:p')], 1)]), _vm._v(" "), _c('p', {
    staticClass: "MsoNormal"
  }, [_c('b', [_c('span', {
    staticStyle: {
      "font-size": "10.0pt",
      "line-height": "115%"
    }
  }, [_c('o:p', [_vm._v(" ")])], 1)])]), _vm._v(" "), _c('p', {
    staticClass: "MsoNormal"
  }, [_vm._m(7), _c('span', {
    staticStyle: {
      "font-family": "\"Arial\",\"sans-serif\""
    }
  }, [_c('o:p')], 1)]), _vm._v(" "), _c('p', {
    staticClass: "MsoNormal"
  }, [_c('b', [_c('span', {
    staticStyle: {
      "font-size": "10.0pt",
      "line-height": "115%"
    }
  }, [_c('o:p', [_vm._v(" ")])], 1)])]), _vm._v(" "), _c('p', {
    staticClass: "MsoNormal has-text-grey"
  }, [_vm._m(8), _c('span', {
    staticStyle: {
      "font-family": "\"Arial\",\"sans-serif\""
    }
  }, [_c('o:p')], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('u', [_c('span', {
    staticStyle: {
      "font-size": "10.0pt"
    },
    attrs: {
      "lang": "EN-CA"
    }
  }, [_vm._v("Assumption of\n\t\t\tRisk")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('u', [_c('span', {
    staticStyle: {
      "font-size": "10.0pt"
    },
    attrs: {
      "lang": "EN-CA"
    }
  }, [_vm._v("Proprietary\n\t\t\tProtection")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('u', [_c('span', {
    staticStyle: {
      "font-size": "10.0pt"
    },
    attrs: {
      "lang": "EN-CA"
    }
  }, [_vm._v("Limitation of\n\t\t\tLiability")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('u', [_c('span', {
    staticStyle: {
      "font-size": "10.0pt"
    },
    attrs: {
      "lang": "EN-CA"
    }
  }, [_vm._v("Indemnification")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "Default"
  }, [_c('u', [_c('span', {
    staticStyle: {
      "font-size": "10.0pt"
    },
    attrs: {
      "lang": "EN-CA"
    }
  }, [_vm._v("Audit Rights and\n\t\t\tNon-Public Personal Information")])]), _c('span', {
    staticStyle: {
      "font-size": "10.0pt"
    },
    attrs: {
      "lang": "EN-CA"
    }
  }, [_vm._v(": ST will have the right to conduct, or direct, during normal business\n\t\t\thours a review of Client’s relevant records to verify Client’s compliance with\n\t\t\tthe terms of this Agreement. This provision does not limit ST’s right to\n\t\t\tinvestigate any conduct it believes may be a breach of the licensing terms or\n\t\t\tmay be otherwise threatening to the integrity of ST or its products or\n\t\t\tservices. ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('u', [_c('span', {
    staticStyle: {
      "font-size": "10.0pt"
    },
    attrs: {
      "lang": "EN-CA"
    }
  }, [_vm._v("Applicable Law\n\t\t\tand Venue")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('u', [_c('span', {
    staticStyle: {
      "font-size": "10.0pt"
    },
    attrs: {
      "lang": "EN-CA"
    }
  }, [_vm._v("Miscellaneous\n\t\t\tProvisions")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b', [_c('span', {
    staticStyle: {
      "font-size": "10.0pt",
      "line-height": "115%",
      "font-family": "\"Arial\",\"sans-serif\""
    }
  }, [_vm._v("TO AGREE TO THESE TERMS, CLICK\n\t\t\t\"AGREE.\" IF YOU DO NOT AGREE TO THESE TERMS, DO NOT CLICK\n\t\t\t\"AGREE.\"")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b', [_c('span', {
    staticStyle: {
      "font-size": "10.0pt",
      "line-height": "115%",
      "font-family": "\"Arial\",\"sans-serif\""
    }
  }, [_vm._v("Copyright 2020 Straticom Technologies R&D Inc.")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-095724a8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/views/terms/tos.vue
// module id = 356
// module chunks = 5